module.exports = __webpack_public_path__ + "img/Project_validated_clicked.90071399.svg";